<template>
  <transition
    name="fade"
    duration="200"
  >
    <div
      v-show="isOpen"
      class="chat-textarea"
      :class="{ dark }"
    >
      <textarea
        v-model="message"
        placeholder="ENTER A MESSAGE..."
        :class="{ dark }"
        @keypress.enter.prevent="sendMessage"
      />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ChatInput',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      message: '',
    }
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),
  },

  methods: {
    sendMessage() {
      this.$emit('enter', this.message)
      this.message = ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.chat-textarea {
  @apply bg-blue-darkest flex items-center justify-center p-2 border border-blue;

  &.dark {
    @apply bg-dark-black;
  }
}

textarea {
  resize: none;
  font-family: 'univia-pro';
  font-size: 20px;
  font-weight: 500;
  min-height: 109px;
  @apply text-center text-blue w-full pt-2 bg-blue-darker;

  &.dark {
    font-family: 'vox';
    @apply bg-dark-black text-blue text-left pl-4;
  }

  &:focus {
    outline: 0;
  }
}
</style>
